var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg01Jspevjg1Ybscgh88Nkrzaz97(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76356 18.1553H4.29688V26.0486H9.76356V18.1553Z",
    fill: "#201F35",
    stroke: "#201F35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.32 10.502H14V23.3286H19.32V10.502Z",
    fill: "#201F35",
    stroke: "#201F35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9667 6.88867H23.5V19.4753H28.9667V6.88867Z",
    fill: "#201F35",
    stroke: "#201F35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 18.1561V13.6494V18.1561Z",
    fill: "#201F35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 18.1561V13.6494",
    stroke: "#201F35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6562 9.8885V5.38184V9.8885Z",
    fill: "#201F35"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6562 9.8885V5.38184",
    stroke: "#201F35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2266 6.79398V4.20898V6.79398Z",
    fill: "#201F35"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2266 6.79398V4.20898",
    stroke: "#201F35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 28.8622V26.0488V28.8622Z",
    fill: "#201F35"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 28.8622V26.0488",
    stroke: "#201F35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6719 26.1416V23.835V26.1416Z",
    fill: "#201F35"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6719 26.1416V23.835",
    stroke: "#201F35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2266 23.3156V19.4756V23.3156Z",
    fill: "#201F35"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2266 23.3156V19.4756",
    stroke: "#201F35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01Jspevjg1Ybscgh88Nkrzaz97);
export default __webpack_public_path__ + "static/media/01JSPEVJG1YBSCGH88NKRZAZ97.c6e81cb9b4bcc254a1be202db61a3b0f.svg";
export { ForwardRef as ReactComponent };